import { previewDashboardSearchSchema } from '@/config/commonSearch';
import { z } from 'zod';

/**
 * Search-param schema for the Executive Summary dashboard.
 *
 * All fields are optional with `.catch` so a malformed URL never throws — the
 * provider computes effective defaults from the project's data bounds at render
 * time. Dates are stored as `'DD-MM-YYYY'` strings (the format produced by
 * `dateToUrlString`).
 */
export const executiveSummarySchema = previewDashboardSearchSchema.extend({
    startDate: z.string().optional().catch(undefined),
    endDate: z.string().optional().catch(undefined),
    compareStartDate: z.string().optional().catch(undefined),
    compareEndDate: z.string().optional().catch(undefined),
    compareEnabled: z.boolean().optional().catch(undefined),
    preset: z
        .union([
            z.literal('last6vsPrev6'),
            z.literal('last6YoY'),
            z.literal('last12vsPrev12'),
            z.literal('custom'),
        ])
        .optional()
        .catch(undefined),
});

export type ExecutiveSummarySearch = z.infer<typeof executiveSummarySchema>;
